import { Navigate, Route, Routes } from 'react-router-dom';
import PageNav from './components/PageNav';
import PageLoader from './components/PageLoader';
import RequireAuth from './components/RequireAuth';
import WelcomePage from './pages/WelcomePage';
import PortfolioPage from './pages/PortfolioPage';
import ResumePage from './pages/ResumePage';
import ContactPage from './pages/ContactPage';
import ApprovalPage from './pages/ApprovalPage';
import AccessRedirect from './pages/AccessRedirect';

export default function App() {
  return (
    <>
      <PageNav />
      <div className="main-view">
        <Routes>
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/access/:access" element={<AccessRedirect />} />

          <Route element={<RequireAuth />}>
            <Route path="/" element={<PortfolioPage />} />
            <Route path="/resume" element={<ResumePage />} />
            <Route path="/resume/:access" element={<ResumePage />} />
          </Route>
          
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/approval" element={<ApprovalPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <PageLoader />
    </>
  );
}
